import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';

/**
 * Shared confirmation shown when a client chooses to APPROVE while they still
 * have an unfulfilled revision request in progress. Used by BOTH VideoReview.js
 * and PhotoReview.js (single source — do NOT duplicate). Controlled via `open`.
 * `onConfirm` runs the EXISTING approve flow (survey -> client-approve); this
 * component adds no business logic, only the explicit confirmation.
 */
export const ApproveAnywayDialog = ({ open, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <AlertDialogContent data-testid="approve-anyway-dialog" className="bg-ug-raised border-ug-border">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-zinc-100">Approve without revisions?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400 leading-relaxed">
          You have a revision request in progress. If you approve now, this version is finalized
          and your downloads unlock — and{' '}
          <span className="text-zinc-200 font-medium">your pending revision request won&apos;t be acted on</span>.
          Your revision notes stay on record. This can&apos;t be undone from your side.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="approve-anyway-cancel" onClick={onCancel}>
          Keep waiting
        </AlertDialogCancel>
        <AlertDialogAction
          data-testid="approve-anyway-confirm"
          onClick={onConfirm}
          className="bg-oxidized-teal hover:bg-oxidized-teal/90 text-white">
          Approve anyway
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
